// extracted by mini-css-extract-plugin
export default {"pinCodeContainer":"pinCodeContainer--RUPBv","digitInput":"digitInput--p8QwW","invalidate":"invalidate--lce3k","withTimeout":"withTimeout--phSQg","wrong":"wrong--FHunF"};